import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '../config/firebase';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    const getAuthHeaders = async () => {
        if (!auth.currentUser) throw new Error('No user logged in');
        const token = await auth.currentUser.getIdToken();
        return {
            'Authorization': `Bearer ${token}`
        };
    };

    const getToken = async () => {
        if (!auth.currentUser) throw new Error('No user logged in');
        return auth.currentUser.getIdToken();
    };

    const refreshUserProfile = async () => {
        if (!auth.currentUser) return null;
        try {
            const token = await auth.currentUser.getIdToken();
            const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
            const response = await fetch(API_URL + '/api/users/me', {
                headers: { 'Authorization': 'Bearer ' + token }
            });
            if (!response.ok) throw new Error('No se pudo actualizar el perfil.');
            const data = await response.json();
            setUserProfile(data.user);
            return data.user;
        } catch (error) {
            console.error('Error refreshing user profile:', error);
            return null;
        }
    };
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                try {
                    const token = await currentUser.getIdToken();
                    const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
                    const response = await fetch(`${API_URL}/api/users/me`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (response.ok) {
                        const data = await response.json();
                        setUserProfile(data.user);
                    }
                } catch (error) {
                    console.error('Error fetching user profile:', error);
                }
            } else {
                setUserProfile(null);
            }
            setLoading(false);
        });
        return unsubscribe;
    }, []);

    const login = (email, password) => {
        return signInWithEmailAndPassword(auth, email, password);
    };

    const logout = () => {
        return signOut(auth);
    };

    const value = {
        user,
        userProfile,
        getAuthHeaders,
        getToken,
        refreshUserProfile,
        login,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
